import { Controller, useFormContext } from 'react-hook-form';
import { WBBox, WBMenuItem, WBSelectV2 } from '@admiin-com/ds-web';
import { DocumentType } from '@admiin-com/ds-graphql';
import { useTranslation } from 'react-i18next';

export const DocumentTypeSelector = () => {
  const { control } = useFormContext();
  const { t } = useTranslation();

  // Generate options from DocumentType, NONE first, rest alphabetically
  const documentTypeValues = Object.values(DocumentType);
  const noneType = DocumentType.NONE;
  const otherTypes = documentTypeValues.filter(
    (type) => type !== DocumentType.NONE
  );

  // Sort other types alphabetically by translated label
  const sortedOtherTypes = otherTypes.sort((a, b) => {
    const labelA = t(a, { ns: 'taskbox' });
    const labelB = t(b, { ns: 'taskbox' });
    return labelA.localeCompare(labelB);
  });

  const documentTypeOptions = [
    { value: noneType, label: t(noneType, { ns: 'taskbox' }) },
    ...sortedOtherTypes.map((type) => ({
      value: type,
      label: t(type, { ns: 'taskbox' }),
    })),
  ];

  return (
    <WBBox>
      <Controller
        control={control}
        name="documentType"
        render={({ field }) => (
          <WBSelectV2
            value={field.value || ''}
            onChange={field.onChange}
            label={t('documentType', {
              ns: 'taskbox',
              defaultValue: 'Tax Document Type',
            })}
          >
            {documentTypeOptions.map((option) => (
              <WBMenuItem key={option.value} value={option.value}>
                {option.label}
              </WBMenuItem>
            ))}
          </WBSelectV2>
        )}
        defaultValue={DocumentType.NONE}
      />
    </WBBox>
  );
};
